<template>
  <div class="container">
    <div class="container mt-5">
      <p class="subtitle has-text-weight-semibold">All Events</p>
      <LogTable :eventList="eventList" :showDelete="showDelete"  @remove-row="updateList"/>
    </div>
  </div>
</template>

<script>
import LogTable from '@/components/LogTable'
import getLogs from '../helpers/fireBaseGet'
import db from '../fireBaseInit'

export default {
  components: {
    LogTable
  },
  data(){
    return {
      eventList: [],
      showDelete: true
    }
  },
  methods:{
    updateList(newList){
      this.eventList = newList
    }
  },
  async created() {
    let loadData = await getLogs(db)
    loadData.forEach(x => {
      this.eventList.push({
        "id": x.id,
        "type": x.data().type,
        "timestamp": x.data().timestamp.toDate()
      })
    })
  }

}
</script>

<style>
</style>